<template lang="pug">
    div(
        class='flex flex-wrap items-center gap-y-2'
        :class="wrapperClasses"
    )
        template(v-for="widget in data.widgets")
            slot(
                :data="widget"
                :spaceLeft="spaceLeft"
            )
</template>

<script>
import { generateGapClasses, generateFlexAlignmentClasses } from '~/integrations/storyblok/helpers'

export default {
    name: 'LevelWidget',
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
        spaceLeft: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        wrapperClasses() {
            return [
                generateFlexAlignmentClasses(
                    this.data.mobileAlignment,
                    this.data.tabletAlignment,
                    this.data.desktopAlignment
                ),
                generateGapClasses(
                    this.data.mobileGutter,
                    this.data.tabletGutter,
                    this.data.desktopGutter
                ),
            ]
        },
    },
}
</script>
